export default "__VITE_ASSET__CWOgRHzn__"